// src/components/admin/TypeChangeStatusBadge.tsx

import React from 'react';
import { Clock, CheckCircle, XCircle } from 'lucide-react';

interface TypeChangeStatusBadgeProps {
    status: 'pending' | 'approved' | 'rejected';
}

const TypeChangeStatusBadge: React.FC<TypeChangeStatusBadgeProps> = ({ status }) => {
    const config = {
        pending: {
            icon: Clock,
            label: 'Pending',
            className: 'bg-yellow-100 text-yellow-800 border-yellow-200',
        },
        approved: {
            icon: CheckCircle,
            label: 'Approved',
            className: 'bg-green-100 text-green-800 border-green-200',
        },
        rejected: {
            icon: XCircle,
            label: 'Rejected',
            className: 'bg-red-100 text-red-800 border-red-200',
        },
    };

    const { icon: Icon, label, className } = config[status];

    return (
        <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border ${className}`}>
            <Icon className="h-3 w-3" />
            {label}
        </span>
    );
};

export default TypeChangeStatusBadge;